import { Component, Input, OnInit } from '@angular/core';
import { Chart, ChartData } from 'chart.js';
import {
	AggressionType,
	AtTime,
	PerAge,
	PerGender,
	PlaceTypes,
} from '../../../core/interfaces/interfaces';

@Component({
	selector: 'app-doughnut-chart',
	templateUrl: './doughnut-chart.component.html',
	styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent implements OnInit {
	@Input() casesPerType: AggressionType;
	@Input() casesPerTime: AtTime;
	@Input() casesPerPlace: PlaceTypes;
	@Input() casesPerAge?: PerAge = {} as PerAge;
	@Input() casesPerGender?: PerGender = {} as PerGender;

	dataSets = [];
	graphType = 0;
	loading = true;

	// TODO fazer o label ser de acordo com a data no from-to
	public barChartLabels = ['2019 - 2022'];
	public chartDataSets = [];
	public barChartType = 'bar';
	public barChartLegend = false;
	public chart: Chart | null;
	public innerWidth: any;

	constructor() {}

	ngOnInit(): void {
		this.createDataSets();
		this.createChart();
	}

	changeGraph(value: string): void {
		this.chart.data.datasets = this.chartDataSets[value];
		this.chart.update();
	}

	createDataSets(): void {
		this.chartDataSets = [
			// SET 1 = Per Type
			[
				{
					label: 'Perseguição',
					data: [this.casesPerType.STALKING],
					backgroundColor: ['rgba(255, 162, 107, .75)'],
				},
				{
					label: 'Intimidação',
					data: [this.casesPerType.COERCION],
					backgroundColor: ['rgba(92, 53, 100, .75)'],
				},
				{
					label: 'Se tocando ou mostrando',
					data: [this.casesPerType.SELF_TOUCH_OR_FLASHING],
					backgroundColor: ['rgba(208, 201, 214, .75)'],
				},
				{
					label: 'Encoxar/Apalpar',
					data: [this.casesPerType.GROPING],
					backgroundColor: ['rgba(71, 184, 129, .75)'],
				},
				{
					label: 'Fotos não autorizadas',
					data: [this.casesPerType.UNWANTED_PHOTOS],
					backgroundColor: ['rgba(247, 209, 84, .75)'],
				},
				{
					label: 'Outros',
					data: [this.casesPerType.OTHERS],
					backgroundColor: ['rgba(255, 100, 124,.75)'],
				},
			],

			// SET 2 = Per Place
			[
				{
					label: 'Ônibus',
					data: [this.casesPerPlace.BUS],
					backgroundColor: ['rgba(255, 100, 124,.75)'],
				},
				{
					label: 'Parada',
					data: [this.casesPerPlace.BUS_STOP],
					backgroundColor: ['rgba(208, 201, 214, .75)'],
				},
				{
					label: 'Terminal',
					data: [this.casesPerPlace.BUS_TERMINUS],
					backgroundColor: ['rgba(247, 209, 84, .75)'],
				},
			],

			// SET 3 = Per Time
			[
				{
					label: 'No momento',
					data: [this.casesPerTime.true],
					backgroundColor: ['rgba(247, 209, 84, .75)'],
				},
				{
					label: 'Após o ocorrido',
					data: [this.casesPerTime.false],
					backgroundColor: ['rgba(208, 201, 214, .75)'],
				},
			],

			// SET 4 = Per Age
			[
				{
					label: '15 - 20',
					data: [this.casesPerAge.LESS_20],
					backgroundColor: ['rgba(247, 209, 84, .75)'],
				},
				{
					label: '21 - 40',
					data: [this.casesPerAge.LESS_40],
					backgroundColor: ['rgba(71, 184, 129, .75)'],
				},
				{
					label: '41 - 60',
					data: [this.casesPerAge.LESS_60],
					backgroundColor: ['rgba(255, 162, 107, .75)'],
				},
				{
					label: '> 60',
					data: [this.casesPerAge.MORE_61],
					backgroundColor: ['rgba(208, 201, 214, .75)'],
				},
			],

			// SET 5 = Per Gender
			[
				{
					label: 'Homem Cis',
					data: [
						this.casesPerGender.MAN_CIS !== undefined
							? this.casesPerGender.MAN_CIS
							: 0,
					],
					backgroundColor: ['rgba(247, 209, 84, .75)'],
				},
				{
					label: 'Mulher Cis',
					data: [
						this.casesPerGender.WOMAN_CIS !== undefined
							? this.casesPerGender.WOMAN_CIS
							: 0,
					],
					backgroundColor: ['rgba(208, 201, 214, .75)'],
				},
				{
					label: 'Não Binário',
					data: [
						this.casesPerGender.NON_BINARY !== undefined
							? this.casesPerGender.NON_BINARY
							: 0,
					],
					backgroundColor: ['rgba(71, 184, 129, .75)'],
				},
				{
					label: 'Homem Trans',
					data: [
						this.casesPerGender.MAN_TRANS !== undefined
							? this.casesPerGender.MAN_TRANS
							: 0,
					],
					backgroundColor: ['rgba(92, 53, 100, .75)'],
				},
				{
					label: 'Mulher Trans',
					data: [
						this.casesPerGender.WOMAN_TRANS !== undefined
							? this.casesPerGender.WOMAN_TRANS
							: 0,
					],
					backgroundColor: ['rgba(255, 162, 107, .75)'],
				},
			],
		];
	}

	createChart(): void {
		const canvas = document.getElementById('myChart') as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');
		const chartdata: ChartData = {
			labels: this.barChartLabels,
			datasets: this.chartDataSets[0],
		};
		this.chart = new Chart(ctx, {
			type: this.barChartType,
			data: chartdata,
			options: {
				responsive: true,
				legend: {
					position: 'bottom',
					align: 'start',
					fullWidth: false,
				},
			},
		});

		this.loading = false;
	}
}
